import * as CubiqTS from "shared/cubiq-model-multi-asset";

export const CHANNEL_TRADE_ACTION: string = "TradeDealActionChannel";

export interface ITradeDealActionService {
  confirmTrade(dealId: string, action: CubiqTS.TradeActionType): Promise<any>;
  confirmTrades(dealIds: Array<string>, action: CubiqTS.TradeActionType): Promise<any>;
  cancelTrade(dealId: string, action: CubiqTS.TradeActionType): Promise<any>;
  cancelTrades(dealIds: Array<string>, action: CubiqTS.TradeActionType): Promise<any>;
  addFillComment(dealId: string, action: CubiqTS.TradeActionType, comment: string): Promise<any>;
}
